//@flow
import React, {Fragment} from 'react';
import {ListItem, ListItemText, Switch} from "@mui/material";
import {useTranslation} from "react-i18next";
import {EXHIBITION} from "../../../locales/components/namespaces";

const RowOptions = ({formik, index, rowField}) => {
	const {t} = useTranslation(EXHIBITION)
	const onClick = e => {
		// e.preventDefault()
		// e.stopPropagation()
	}
	const field = formik.values.fields.find(f => f.id === rowField.id)
	const fieldIndex = formik.values.fields.findIndex(f => f.id === rowField.id)

	return (
		<Fragment>
			<ListItem onClick={onClick}>
				<ListItemText primary={t("Required")}/>
				<Switch
					edge="end"
					name={`fields[${fieldIndex}].required`}
					onChange={formik.handleChange}
					onBlur={formik.handleBlur}
					checked={formik.values.fields[fieldIndex].required}
				/>
			</ListItem>
			<ListItem onClick={onClick}>
				<ListItemText primary={t("Enabled")}/>
				<Switch
					edge="end"
					name={`fields[${fieldIndex}].enabled`}
					onChange={formik.handleChange}
					onBlur={formik.handleBlur}
					checked={formik.values.fields[fieldIndex].enabled}
				/>
			</ListItem>
			{field.type !== "surname" && (
				<ListItem onClick={onClick}>
					<ListItemText
						primary={t("Visible on registration form")}
					/>
					<Switch
						edge="end"
						name={`fields[${fieldIndex}].visibleOnRegistrationForm`}
						onChange={formik.handleChange}
						onBlur={formik.handleBlur}
						checked={formik.values.fields[fieldIndex].visibleOnRegistrationForm}
					/>
				</ListItem>
			)}
			<ListItem onClick={onClick}>
				<ListItemText
					primary={t("Visible on preregistration form")}
				/>
				<Switch
					edge="end"
					name={`fields[${fieldIndex}].visibleOnPreRegistrationForm`}
					onChange={formik.handleChange}
					onBlur={formik.handleBlur}
					checked={formik.values.fields[fieldIndex].visibleOnPreRegistrationForm}
				/>
			</ListItem>
			{field.type !== "surname" && (
				<ListItem onClick={onClick}>
					<ListItemText
						primary={t("Visible on confirmation display")}
						secondary={t("Disable this option if you want to hide this field from visitor display after a badge is scanned.")}
					/>
					<Switch
						edge="end"
						name={`fields[${fieldIndex}].visibleOnConfirmationDisplay`}
						onChange={formik.handleChange}
						onBlur={formik.handleBlur}
						checked={formik.values.fields[fieldIndex].visibleOnConfirmationDisplay}
					/>
				</ListItem>
			)}
			<ListItem onClick={onClick}>
				<ListItemText
					primary={t("Visible on Company Group")}
					secondary={t("Enable this option to place field in Company Group Of Preregistration Form. If disabled field will be placed in Personal Information Group.")}
				/>
				<Switch
					edge="end"
					name={`fields[${fieldIndex}].groupOfCompany`}
					onChange={formik.handleChange}
					onBlur={formik.handleBlur}
					checked={formik.values.fields[fieldIndex].groupOfCompany}
				/>
			</ListItem>
			{field.type === "interests" && (
				<Fragment>
					<ListItem onClick={onClick}>
						<ListItemText
							primary={t("Allow Multiple Selection")}
						/>
						<Switch
							edge="end"
							name={`fields[${fieldIndex}].multiple`}
							onChange={formik.handleChange}
							onBlur={formik.handleBlur}
							checked={formik.values.fields[fieldIndex].multiple}
						/>
					</ListItem>
					<ListItem onClick={onClick}>
						<ListItemText
							primary={t("Allow Adding New")}
						/>
						<Switch
							edge="end"
							name={`fields[${fieldIndex}].addNew`}
							onChange={formik.handleChange}
							onBlur={formik.handleBlur}
							checked={formik.values.fields[fieldIndex].addNew}
						/>
					</ListItem>
				</Fragment>
			)}
			{field.type === "email" && (
				<ListItem onClick={onClick}>
					<ListItemText
						primary={t("Display Confirm Email Field In Preregistration")}
						secondary={t("Enable this option to display a second email field for email confirmation check.")}
					/>
					<Switch
						edge="end"
						name={`fields[${fieldIndex}].confirmEmailInPreRegistration`}
						onChange={formik.handleChange}
						onBlur={formik.handleBlur}
						checked={formik.values.fields[fieldIndex].confirmEmailInPreRegistration}
					/>
				</ListItem>
			)}
			{field.type === "vat" && (
				<>
					<ListItem onClick={onClick}>
						<ListItemText
							primary={t("Activate Taxis Search on Preregistration")}
							secondary={t("Enable this option to allow searching Tax Registration Number in TAXIS API on preregistration form.")}
						/>
						<Switch
							edge="end"
							name={`fields[${fieldIndex}].enableTaxisSearchPreregistration`}
							onChange={formik.handleChange}
							onBlur={formik.handleBlur}
							checked={formik.values.fields[fieldIndex].enableTaxisSearchPreregistration}
						/>
					</ListItem>
					<ListItem onClick={onClick}>
						<ListItemText
							primary={t("Activate Taxis Search on Registration")}
							secondary={t("Enable this option to allow searching Tax Registration Number in TAXIS API on registration form.")}
						/>
						<Switch
							edge="end"
							name={`fields[${fieldIndex}].enableTaxisSearchRegistration`}
							onChange={formik.handleChange}
							onBlur={formik.handleBlur}
							checked={formik.values.fields[fieldIndex].enableTaxisSearchRegistration}
						/>
					</ListItem>
				</>
			)}
		</Fragment>
	)
}

export default RowOptions;
